import { Component, Input, ElementRef, OnInit, OnDestroy, ContentChild, TemplateRef, EventEmitter } from '@angular/core';

import { CoreConfigService } from '../../../services/config/core-config.service';
import { AppSwitcherService } from '../../../services/service/app-switcher.service';
import { OfficeSwitcherService } from '../../../services/service/office-switcher.service';

@Component({
    selector: 'zx-applet-selector',
    templateUrl: './applet-selector.component.html',
    styleUrls: ['./applet-selector.component.css'],
})
export class AppletSelectorComponent implements OnInit,OnDestroy {

    collapseMode = true;
    isModalVisible = false;
    tempAppletRoot:any;

    @ContentChild('content', {static:true}) tpl_content: TemplateRef<{}>;
    @ContentChild('modalTitle', {static:true}) modalTitle: TemplateRef<{}>;
    @ContentChild('modalFooter', {static:true}) modalFooter: TemplateRef<{}>;

    constructor(
        public appSwitcher: AppSwitcherService,
		public configService: CoreConfigService,
        public officeSwitcher: OfficeSwitcherService,
    ) {
        this.collapseMode = (this.configService.appletsSelectMode=="COLLAPSE");
        this.appSwitcher.registerSelector(this);
     }

    ngOnInit() { }
    ngOnDestroy(){ }
    
    get canActiveSelector():boolean{
        const root = this.appletsTree;
        if(this.appSwitcher.canOpenSelector && root && root.children && root.children.length > 0){
            const visibles = root.children.filter(item=>item.visible);
            if(visibles.length == 0) return false;
            if(visibles.length > 1 || visibles[0].resourceType=='APPLICATION_SET') return true;
        }
        return false;
    }

    get collapseTitle(): string{
        const theRoot = (this.collapseMode ? this.appletsTree : this.appletsRoot);
        return theRoot == null ? "切换应用" : theRoot.fullDisplayName;
    }
    get currentApplet(): any{
        return this.appSwitcher.currentApp;
    }
    get appletsTree(): any{
        return this.appSwitcher.appletsTree;
    }
    get appletGroups():any[]{
        const groups = this.appletsTree&&this.appletsTree.children ? this.appletsTree.children.filter(item=>item.visible&&item.resourceType=="APPLICATION_SET") : [];
        return groups;
    }
    get appletsRoot(): any{
        if(this.tempAppletRoot==null){
            const parentId = this.currentApplet?this.currentApplet.parentId:null;
            this.tempAppletRoot = parentId!=null?this.appSwitcher.findApp(parentId):null;
        }
        return this.tempAppletRoot;
    }

    get isDataLoading(): boolean{
        return !this.appSwitcher.isReady;
    }
    isLock(applet:any){
        return this.appSwitcher.isAppLock(applet);
    }
    go(applet: any) {
        if(applet.resourceType=="APPLICATION_SET"){
            this.tempAppletRoot = applet;
        }else if(applet&&applet.resourceType=="APPLICATION"&&!this.isLock(applet)){
            this.closeModal();
            this.appSwitcher.navigateTo(applet);
        }
    }

    openOfficeSelector() {
        this.closeModal();
        this.officeSwitcher.openSelector();
    }
    showModal() {
        if(this.canActiveSelector) this.isModalVisible = true;
    }

    closeModal() {
        this.isModalVisible = false;
    }
}
